<template>
  <a-space-compact :block="!showIconOnly" :class="bem.b()" :size="size">
    <ll-input
      v-if="!showIconOnly"
      v-bind="attrs"
      v-model:value="newValue"
      :class="[bem.e('input')]"
      :readonly="props.readonly"
    >
      <template #suffix>
        <ll-icon :icon-name="'icon-' + value" :size="iconSize" />
      </template>
    </ll-input>

    <ll-button
      :disabled="attrs.disabled"
      :class="[bem.e('btn')]"
      @click="handleModal"
    >
      <template #icon>
        <ll-icon
          :icon-name="showIconOnly ? 'icon-' + newValue : 'icon-select-icon'"
          :size="iconSize"
        />
      </template>
    </ll-button>
  </a-space-compact>
</template>
<script lang="ts" setup>
import { computed, useAttrs } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { iconPickerSearchEmits, iconPickerSearchProps } from '../config'

defineOptions({
  name: 'LlIconPickerSearch',
})

const props = defineProps(iconPickerSearchProps)
const emits = defineEmits(iconPickerSearchEmits)

const attrs = useAttrs()
const bem = createNamespace('icon-picker-search')
const handleModal = () => emits('handleModal', true)

const newValue = computed({
  get() {
    return props.value
  },
  set(value) {
    emits('update:value', value)
    emits('change', value)
  },
})

const iconSize = computed(() =>
  props.size === 'large' ? 20 : props.size === 'small' ? 14 : 18,
)
</script>
